var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"map"}},[_c('div',{staticClass:"map-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }